import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import LicenseService from "../../../services/LicensesService";
import { FormDiscountReason } from "./FormDiscountReason";
import { useEffect, useState } from "react";

export function EditDiscountReason({ ...props }) {
   const { discountReasonId } = useParams();
   const { state } = useLocation();
   const [discountReason, setDiscountReason] = useState(state);
   const [type, setType] = useState("");

   async function loadDiscountReason(id) {
      const response = await LicenseService.getDiscountReason(id);
      if (response.data) {
         setDiscountReason(response.data);
      }
   }

   useEffect(() => {
      setType(discountReasonId || state ? "edicao" : "cadastro");

      if (discountReason) {
         setDiscountReason(state);
         return;
      }

      if (discountReasonId) {
         loadDiscountReason(discountReasonId);
      }
   }, [state, discountReasonId]);

   return (
      <CadastroContainer>
         <FormDiscountReason discountReason={discountReason} type={type} />
      </CadastroContainer>
   );
}